import { useState } from 'react'
import { wishlistAPI } from '../services/api'

const PRIORITIES = [
  { value: 'high', label: '🔴 Tinggi' },
  { value: 'medium', label: '🟡 Sedang' },
  { value: 'low', label: '🟢 Rendah' },
]

export default function WishlistForm({ item, onClose, onSuccess }) {
  const [form, setForm] = useState({
    name: item?.name || '',
    price: item?.price 
      ? String(item.price).replace(/\B(?=(\d{3})+(?!\d))/g, '.') 
      : '',
    priority: item?.priority || 'medium',
    url: item?.url || '',
    notes: item?.notes || '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const formatAmount = (value) => {
    const numbers = value.replace(/\D/g, '')
    return numbers.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const numericPrice = parseInt(form.price.replace(/\D/g, ''))

    if (!form.name.trim() || !numericPrice) {
      setError('Nama item dan harga wajib diisi')
      return
    }

    setLoading(true)
    try {
      const payload = {
        name: form.name.trim(),
        price: numericPrice,
        priority: form.priority,
        url: form.url.trim() || null,
        notes: form.notes.trim() || null,
      }

      if (item?.id) {
        await wishlistAPI.update(item.id, payload)
      } else {
        await wishlistAPI.create(payload)
      }
      onSuccess()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-sm max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-lg">
              {item?.id ? 'Edit Wishlist' : 'Tambah Wishlist'}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
          </div>

          {error && (
            <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm mb-4">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label className="label">Nama Item *</label>
              <input
                type="text"
                placeholder="Nama barang yang diinginkan"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="input-field"
                autoFocus
              />
            </div>

            {/* Price */}
            <div>
              <label className="label">Harga *</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">Rp</span>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="0"
                  value={form.price}
                  onChange={(e) => setForm({ ...form, price: formatAmount(e.target.value) })}
                  className="input-field pl-10"
                />
              </div>
            </div>

            {/* Priority */}
            <div>
              <label className="label">Prioritas</label>
              <div className="flex gap-2">
                {PRIORITIES.map((p) => (
                  <button
                    key={p.value}
                    type="button"
                    onClick={() => setForm({ ...form, priority: p.value })}
                    className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-all ${
                      form.priority === p.value
                        ? 'bg-primary text-white'
                        : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                    }`}
                  >
                    {p.label}
                  </button>
                ))}
              </div>
            </div>

            {/* URL */}
            <div>
              <label className="label">Link Produk (Opsional)</label>
              <input
                type="url"
                placeholder="https://..."
                value={form.url}
                onChange={(e) => setForm({ ...form, url: e.target.value })}
                className="input-field"
              />
            </div>

            {/* Notes */}
            <div>
              <label className="label">Catatan (Opsional)</label>
              <textarea
                placeholder="Tambahkan catatan..."
                value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })}
                className="input-field resize-none"
                rows={3}
              />
            </div>

            <div className="flex gap-3 pt-2">
              <button type="button" onClick={onClose} className="btn-secondary flex-1">
                Batal
              </button>
              <button
                type="submit"
                disabled={loading || !form.name || !form.price}
                className="btn-primary flex-1 disabled:opacity-50"
              >
                {loading ? 'Menyimpan...' : item?.id ? 'Update' : 'Simpan'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
